import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getApiUrl, API_ENDPOINTS } from '../config/apiConfig';

const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: var(--bg-color);
    color: var(--primary-color);
`;

const AdminOnlyRoute = ({ children }) => {
    const [isAuthorized, setIsAuthorized] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        checkAdminRole();
    }, []);

    const checkAdminRole = async () => {
        try {
            const response = await fetch(getApiUrl(API_ENDPOINTS.CHECK_AUTH), {
                credentials: 'include'
            });
            
            if (!response.ok) {
                throw new Error('Auth check failed');
            }
            
            const data = await response.json();
            
            if (data.success && data.user && data.user.role === 'admin') {
                setIsAuthorized(true);
            } else {
                setIsAuthorized(false);
                navigate('/admin');
            }
        } catch (error) {
            console.error('Admin check error:', error);
            setIsAuthorized(false);
            navigate('/admin');
        }
    };

    if (isAuthorized === null) {
        return (
            <LoadingContainer>
                <div>Yetki kontrol ediliyor...</div>
            </LoadingContainer>
        );
    }

    if (!isAuthorized) {
        return null;
    }

    return children;
};

export default AdminOnlyRoute;

